function showKeyvisualImage() {
  const keyvisualImg = $('.keyvisual__img');
  if (keyvisualImg.length) {
    keyvisualImg.removeClass('hidden');
  }
}

function initializeHeroSection() {
  const video = $('#valx-video')[0];

  if (!video) return;

  let hasEnded = false;

  $(video).addClass('video').removeClass('hidden');
  $(video).on('ended', function () {
    if (!hasEnded) {
      hasEnded = true;
      // 動画を最後のフレームで停止
      video.pause();
      video.currentTime = video.duration - 0.1;
      video.removeAttribute('autoplay');
    }
  });
}

$(window).on('load', function () {
  initializeHeroSection();

  $('.women-slider').slick({
    autoplay: true,
    infinite: true,
    dots: true,
    centerPadding: '20%',
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    variableWidth: true,
  });
  $('.monitor__slider').slick({
    autoplay: true,
    infinite: true,
    dots: true,
    centerPadding: '20%',
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    variableWidth: true,
  });
  $('.howtouse__slider').slick({
    autoplay: true,
    infinite: true,
    dots: true,
    centerPadding: '20%',
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    variableWidth: true,
  });

  $('.accordion').each(function () {
    $(this)
      .find('.faq_q')
      .click(function () {
        $(this).toggleClass('active');
        $(this).toggleClass('selected');
        $(this).next().slideToggle();
      });
  });
});

$(document).ready(function () {
  $('.faq__answer').hide();

  $('.faq__question').click(function () {
    $(this).toggleClass('active');
    $(this).next('.faq__answer').slideToggle(300);
  });
});
